import { loadRoute } from "../helpers/misc";
const AsyncISLMatchSchedulePage = loadRoute(() => import(/* webpackChunkName: "ISLMatchSchedulePage" */ "../containers/IPLMatchScheduleWithSubscription"));
export default AsyncISLMatchSchedulePage;
